<template>
  <v-app>
    <v-main>
      <Main />
      <audio ref="bgm" :src="musicSrc" loop preload="auto"></audio>
    </v-main>
  </v-app>
</template>

<script>
import Main from './components/SaveTheDate.vue';

export default {
  name: 'App',

  components: {
    Main,
  },

  data: () => ({
    musicSrc: './music.mp3'
  }),
  mounted() {
    document.addEventListener('click', this.playMusic, { once: true });
  },
  methods: {
    playMusic() {
      this.$refs.bgm.play();
    }
  }
};
</script>
<style>
#audio {
  transition: opacity 1.5s ease-in;
}
</style>